(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabsSlider {
    constructor(section) {
      this.container = section;
      this.tabs = this.container.querySelectorAll('.collection-tabs__tab-button');
      this.contents = this.container.querySelectorAll('[data-collection-content]');
      this.productsPerMobileSlide = parseInt(this.container.dataset.productsPerMobileSlide) || 1;
      this.viewAllLink = this.container.querySelector('[data-view-all-link]'); // REQ 2: Find the link
      this.initTabs();
      this.initSliders();
    }

    initTabs() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          this.updateActiveTab(tab);
          this.updateVisibleContent(tab.dataset.collectionHandle);
          this.updateViewAllLink(tab.dataset.collectionUrl); // REQ 2: Update link on click
        });
      });
    }

    // REQ 2: New function to update the View All link
    updateViewAllLink(collectionUrl) {
      if (this.viewAllLink) {
        this.viewAllLink.href = collectionUrl;
      }
    }

    updateActiveTab(activeTab) {
      this.tabs.forEach(tab => tab.classList.remove('is-active'));
      activeTab.classList.add('is-active');
    }

   updateVisibleContent(targetHandle) {
      let newVisibleContent = null; // To find the new tab panel
      
      this.contents.forEach(content => {
        const isTarget = content.dataset.collectionHandle === targetHandle;
        content.classList.toggle('hidden', !isTarget);
        if (isTarget) {
          newVisibleContent = content; // We found the panel we just made visible
        }
      });
      
      this.initSliders(); 

      // THIS IS THE FIX:
      // We manually find all <product-form> components inside the
      // new panel and tell the browser to "upgrade" (initialize) them.
      // This wakes up the single-variant "Add to Cart" buttons.
      if (newVisibleContent && typeof customElements.get('product-form') !== 'undefined') {
        newVisibleContent.querySelectorAll('product-form').forEach((form) => {
          customElements.upgrade(form);
        });
      }
    }

    initSliders() {
      const visibleContent = this.container.querySelector('[data-collection-content]:not(.hidden)');
      if (!visibleContent) return;
      if (typeof customElements.get('product-form') !== 'undefined') {
        visibleContent.querySelectorAll('product-form').forEach((form) => {
          customElements.upgrade(form);
        });
      }
      const productList = visibleContent.querySelector('[data-product-list]');
      const nextButton = visibleContent.querySelector('[data-slider-next]');
      const prevButton = visibleContent.querySelector('[data-slider-prev]');
      const dotsContainer = visibleContent.querySelector('[data-slider-dots]');
      
      if (!productList || !nextButton || !prevButton || !dotsContainer) return;
      
      const items = productList.querySelectorAll('.collection-tabs__product-item');
      const totalItems = items.length;
      
      // REQ 1: If no items (due to limit), hide navigation
      if (totalItems <= 4) {
        const navigation = visibleContent.querySelector('.collection-tabs__navigation');
        if(navigation) navigation.classList.add('hidden');
      }

      let currentIndex = 0;
      dotsContainer.innerHTML = '';
      
      const getItemsPerSlide = () => {
        if (window.innerWidth <= 749) return this.productsPerMobileSlide;
        if (window.innerWidth <= 990) return 3;
        return 4;
      };
      
      const updateSliderUI = () => {
        const itemsPerSlide = getItemsPerSlide();
        const maxIndex = Math.ceil(totalItems / itemsPerSlide) - 1;
        
        if (currentIndex > maxIndex) currentIndex = maxIndex;
        
        if (dotsContainer.innerHTML === '' && maxIndex > 0) {
          for (let i = 0; i <= maxIndex; i++) {
            const dot = document.createElement('button');
            dot.classList.add('collection-tabs__dot');
            dot.dataset.index = i;
            dot.addEventListener('click', () => { currentIndex = i; updateSlider(); });
            dotsContainer.appendChild(dot);
          }
        }
        updateSlider();
      };
      
      const updateSlider = () => {
        const itemsPerSlide = getItemsPerSlide();
        const maxIndex = Math.ceil(totalItems / itemsPerSlide) - 1;
        const offset = currentIndex * 100;
        
        productList.style.transform = `translateX(-${offset}%)`;
        prevButton.disabled = currentIndex === 0;
        nextButton.disabled = currentIndex >= maxIndex;
        
        dotsContainer.querySelectorAll('.collection-tabs__dot').forEach((dot, index) => {
          dot.classList.toggle('is-active', index === currentIndex);
        });
      };
      
      nextButton.addEventListener('click', () => {
        const maxIndex = Math.ceil(totalItems / getItemsPerSlide()) - 1;
        if (currentIndex < maxIndex) { currentIndex++; updateSlider(); }
      });
      
      prevButton.addEventListener('click', () => {
        if (currentIndex > 0) { currentIndex--; updateSlider(); }
      });
      
      window.addEventListener('resize', updateSliderUI);
      updateSliderUI();
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.collection-tabs-section').forEach(section => new CollectionTabsSlider(section));
  });
  
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.collection-tabs-section');
    if (section) new CollectionTabsSlider(section);
  });
  
  document.addEventListener('shopify:section:select', (e) => {
    const section = e.target.querySelector('.collection-tabs-section');
    if (section) new CollectionTabsSlider(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }
      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);
        const isPopularSearchesMobile = this.closest('.popular-searches--mobile') !== null;
this.disclosure.open = isLargeScreen || isConfirmNewsletter || isPopularSearchesMobile;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }
    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  // CTA Dropdown Button Functionality
  document.addEventListener('DOMContentLoaded', function() {
    const dropdowns = document.querySelectorAll('.header-cta-dropdown');
    
    dropdowns.forEach(dropdown => {
      const button = dropdown.querySelector('.header-cta-dropdown__toggle');
      const menu = dropdown.querySelector('.header-cta-dropdown__menu');
      
      if (button && menu) {
        // Toggle dropdown on button click
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          menu.classList.toggle('is-open');
        });
        
        // Close dropdown when a link is clicked
        const links = menu.querySelectorAll('a');
        links.forEach(link => {
          link.addEventListener('click', function() {
            menu.classList.remove('is-open');
          });
        });
      }
    });

    // Close all dropdowns when clicking outside
    document.addEventListener('click', function(event) {
      dropdowns.forEach(dropdown => {
        const menu = dropdown.querySelector('.header-cta-dropdown__menu');
        if (!dropdown.contains(event.target) && menu) {
          menu.classList.remove('is-open');
        }
      });
    });

    // Close dropdown on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        dropdowns.forEach(dropdown => {
          const menu = dropdown.querySelector('.header-cta-dropdown__menu');
          if (menu) {
            menu.classList.remove('is-open');
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
